import { axios } from '@/utils/http'
import { ArtStudent, ArtStudentList } from '@/models/enroll/artStudent'
/**
 * 获取列表
 * @param url apiurl
 */
export async function getList() {
  const { data } = await axios.get(`student/ArtStudentEnroll`)
  const result = data as ArtStudentList
  return result
}

/**
 * 获取列表
 * @param url apiurl
 */
export async function getQueryedList(limit: number, offset: number) {
  const { data } = await axios.get(
    `student/ArtStudentEnroll?limit=${limit}&offset=${offset}`
  )
  const result = data as ArtStudentList
  return result
}

/**
 * 获取某一model
 * @param url url
 * @param id id
 */
export async function get(id: string) {
  const { data } = await axios.get(`student/ArtStudentEnroll/${id}`)
  return data as ArtStudent
}

/**
 * 创建某一model
 * @param url url
 * @param model id
 */
export async function post(model: ArtStudent) {
  const { data } = await axios.post(`student/ArtStudentEnroll`, model)
  return data as ArtStudent
}

/**
 * 修改某一model
 * @param url url
 * @param id id
 * @param model id
 */
export async function put(id: string, model: ArtStudent) {
  await axios.put(`student/ArtStudentEnroll/${id}`, model)
}

/**
 * 删除某一model
 * @param url url
 * @param id id
 * @param model id
 */
export async function del(id: string) {
  await axios.delete(`student/ArtStudentEnroll/${id}`)
}
